/**
 * ...
 * @author Xibin Liu
 */
/**
 * package: com.inq.utils
 * class: JsonML
 * root Object
 * @constructor
 */
com.inq.utils.JsonML = function() {};
$hxClasses['com.inq.utils.JsonML'] = com.inq.utils.JsonML;
/** @private @type {Array} */
com.inq.utils.JsonML.__name__ = ["com","inq","utils","JsonML"];


/**
 * jsonToXml - convert JsonML array to Xml Object
 *
 * public static function jsonToXml(jsonArray:Array)
 * @public
 * @static
 * @param {array}  jsonArray - the JsonML array
 * @return {Xml}
 */
com.inq.utils.JsonML.jsonToXml = function(jsonArray) {
    /** @type {Xml} */
	var xmlDoc = Xml.createDocument();
	com.inq.utils.JsonML._jsonToXmlNode(jsonArray, xmlDoc);

	return xmlDoc;
};


/**
 * _jsonToXmlNode - convert JsonML array to Xml Object
 *
 * private static function _jsonToXmlNode(jsonArray:Array)
 * @private
 * @static
 * @param {array}  jsonArray - the JsonML array
 * @param {Xml}  parent - the parent Xml node
 * @return {void}
 */
com.inq.utils.JsonML._jsonToXmlNode = function(jsonArray, parent) {
	/** @type {string} */
	var name;
	
	if (!Array.isArray(jsonArray) || jsonArray.length == 0) {
		haxe.Log.trace("Error: Could not run _jsonToXmlNode. Object is Not an JsonML array: " + jsonArray, { fileName : "JsonML.js", lineNumber : 99, className : "com.inq.utils.JsonML", methodName : "_jsonToXmlNode"});
		return;
	}
	
	name = jsonArray[0];
	
	var xml = Xml.createElement(name);
	parent.addChild(xml);
	
	//set attributes
	if (jsonArray.length > 1 && typeof jsonArray[1] === "object" && !Array.isArray(jsonArray[1])) {
		var propertyObj = jsonArray[1];
		for (var property in propertyObj) {
		    if (propertyObj.hasOwnProperty(property)) {
		    	var value = propertyObj[property];
		    	//note: the value must be converted to string, which is the case in original MXML
		    	xml.set(property, value.toString());
		    }
		}
	}

	//always loop from the first element
	for (var i = 1; i < jsonArray.length; i++) {
		var item = jsonArray[i];
		
		//This item is an attributes object of the parent array
		if (typeof item === "object" && !Array.isArray(item)) {
			continue;
		}

		//check each element now...
		if (typeof item === "string") {
			//if a string node
			var pcdata = Xml.createPCData(item);
			xml.addChild(pcdata);
		}
		else {
			//if an array node
			com.inq.utils.JsonML._jsonToXmlNode(item, xml);
		}
	}
};

/** @type {com.inq.utils.JsonML} */
com.inq.utils.JsonML.prototype.__class__ = com.inq.utils.JsonML;
